//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect } from 'react'
import './FullSchedule.css'
import { useParams, Link } from 'react-router-dom'
import Footer from '../components/UIElements/Footer'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
//import FilterByTeam from '../components/UIElements/FilterByTeam'

const TeamSchedule = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [leagueId, setLeagueId] = useState()
	const [wins, setWins] = useState()
	const [losses, setLosses] = useState()
	const [overtimeLosses, setOvertimeLosses] = useState()
	const [shootoutLosses, setShootoutLosses] = useState()
	const [ties, setTies] = useState()
	const [allTeamGames, setAllTeamGames] = useState([])
	const [teamId, setTeamId] = useState()

	const leagueName = useParams().leagueName
	const session = useParams().session
	const year = useParams().year
	const teamName = useParams().teamName
	//const teamId = useParams().teamId

	console.log('inside TeamSchedule.js')
	console.log('leagueName: ' + leagueName)
	console.log('session: ' + session)
	console.log('teamName: ' + teamName)
	console.log('year: ' + year)
	console.log(useParams())

	//Get all games for a team.  getTeamSchedule2.  Also returns teamId.
	useEffect(() => {
		console.log('INSIDE USE EFFECT 17')
		const sendRequest = async () => {
			setIsLoading(true)
			//setAllTeamGames([])
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/teamSchedule/${leagueName}/${session}/${year}/${teamName}`
					//`${process.env.REACT_APP_BACKEND_URL}/league/teamSchedule/${teamId}`
				)

				const responseData = await response.json()

				console.log('responseData 17: ' + JSON.stringify(responseData))

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllTeamGames(responseData.allTeamGamesArray)
				setTeamId(responseData.teamId)
				setWins(responseData.wins)
				setLosses(responseData.losses)
				setOvertimeLosses(responseData.overtimeLosses)
				setShootoutLosses(responseData.shootoutLosses)
				setTies(responseData.ties)
				setLeagueId(responseData.leagueId)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	console.log('ties: ' + ties)
	console.log('overtimeLosses: ' + overtimeLosses)
	console.log('shootoutLosses: ' + shootoutLosses)
	console.log('leagueId: ' + leagueId)
	allTeamGames &&
		!isLoading &&
		console.log('allTeamGamesArray: ' + JSON.stringify(allTeamGames[0]))

	//
	//
	//
	//allTeamGames &&
	//	!isLoading &&
	//	console.log('score: ' + JSON.stringify(allTeamGames[0]).score)
	//
	//
	//
	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	let rem

	if (allTeamGames) {
		if (allTeamGames.length > 10) {
			rem = '2rem'
		} else {
			rem = '20rem'
		}
	}
	//
	//
	let dateBlock
	dateBlock = []
	if (!isLoading && allTeamGames.length === 0) {
		return (
			<React.Fragment>
				<SchedulesHomeNavigation />
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (!isLoading && allTeamGames.length !== 0) {
		dateBlock.push(
			<div className='Schedule' style={{ marginTop: '7rem' }}>
				<h1>{allTeamGames[0].leagueName + ' ' + teamName} - Team Schedule</h1>
				<h3 className='h3Center'>
					{allTeamGames[0].session + ' ' + allTeamGames[0].year}
				</h3>
				<h3 className='h3Center'>
					Record: {wins} - {losses} - {ties + shootoutLosses + overtimeLosses}
				</h3>
				<p>(Click on the final score of a game to see a Game Summary)</p>
				<table id='teamScheduleDisplay'>
					<thead>
						<tr>
							<th>Date</th>
							<th>Time</th>
							<th>Score</th>
							<th></th>
							<th>Visitor/Home</th>
							<th>Venue</th>
						</tr>
					</thead>
					<tbody>
						{allTeamGames.map((game, key) => {
							// if (game.venueName === venue) {
							return (
								<tr key={key}>
									<td>
										{game.dayOfWeek}
										{', '}
										{game.date.substr(0, 2) === '01' &&
											'Jan. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '02' &&
											'Feb. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '03' &&
											'Mar. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '04' &&
											'Apr. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '05' &&
											'May ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '06' &&
											'June ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '07' &&
											'July ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '08' &&
											'Aug. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '09' &&
											'Sept. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '10' &&
											'Oct. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '11' &&
											'Nov. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '12' &&
											'Dec. ' + game.date.substr(3, 2)}
									</td>
									<td>
										{game.time.substr(0, 2) === '00' &&
											'12:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '01' &&
											'1:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '02' &&
											'2:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '03' &&
											'3:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '04' &&
											'4:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '05' &&
											'5:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '06' &&
											'6:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '07' &&
											'7:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '08' &&
											'8:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '09' &&
											'9:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '10' &&
											'10:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '11' &&
											'11:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '12' &&
											'12:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '13' &&
											'1:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '14' &&
											'2:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '15' &&
											'3:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '16' &&
											'4:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '17' &&
											'5:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '18' &&
											'6:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '19' &&
											'7:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '20' &&
											'8:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '21' &&
											'9:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '22' &&
											'10:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '23' &&
											'11:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '24' &&
											'12:' + game.time.substr(3, 2) + ' am'}
									</td>
									{!game.score && <td></td>}
									{game.score && !game.winner && !game.loser && (
										<td style={{ color: 'black', fontWeight: 'bold' }}>
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
												to={`/gameSummary/${game._id}`}
											>
												TIED {game.score}
											</Link>
										</td>
									)}
									{game.loser === teamId && (
										<td style={{ color: 'red', fontWeight: 'bold' }}>
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'red',
												}}
												to={`/gameSummary/${game._id}`}
											>
												LOST {game.score}
											</Link>
										</td>
									)}
									{game.winner === teamId && (
										<td style={{ color: 'green', fontWeight: 'bold' }}>
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'green',
												}}
												to={`/gameSummary/${game._id}`}
											>
												WON {game.score}
											</Link>
										</td>
									)}
									<td style={{ color: 'red', fontWeight: 'bold' }}>
										{game.playoff && game.description}
									</td>
									{game.visitorTeamName && game.eventKey && (
										<td>
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
												to={`https://www.sporfie.com/event/${game.eventKey}`}
											>
												{game.visitorTeamSeed > 0 &&
													'(' + game.visitorTeamSeed + ') '}
												{game.visitorTeamName && game.visitorTeamName}
												{' @ '}
												{<span>{<br />}</span>}
												{game.homeTeamSeed > 0 &&
													'(' + game.homeTeamSeed + ') '}
												{game.homeTeamName && game.homeTeamName}
											</Link>
										</td>
									)}
									{game.visitorTeamName && !game.eventKey && (
										<td>
											{game.visitorTeamSeed > 0 &&
												'(' + game.visitorTeamSeed + ') '}
											{game.visitorTeamName && game.visitorTeamName}
											{' @ '}
											{<span>{<br />}</span>}
											{game.homeTeamSeed > 0 && '(' + game.homeTeamSeed + ') '}
											{game.homeTeamName && game.homeTeamName}
										</td>
									)}
									<td>{game.venueName}</td>
								</tr>
							)
							//}
						})}
					</tbody>
				</table>
			</div>
		)
		// }
		//)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation />
				{dateBlock && dateBlock}
				<div style={{ marginTop: `${rem}` }}>
					<Footer />
				</div>
			</React.Fragment>
		</div>
	)
}

export default TeamSchedule
